import { defineComponent } from 'vue';
import { Flow } from '@hems/component';
import { defaultEnergyFlow } from '@hems/container/src/energyflow/flow/EnergyFlowFunctions';
import { FLOW_ANIMATION } from '@hems/util/src/constant';
export default defineComponent({
    name: 'EnergyFlowAC',
    components: {
        Flow,
    },
    props: {
        energyFlow: {
            type: Object,
            default: () => defaultEnergyFlow,
        },
    },
    setup() {
        return {
            FLOW_ANIMATION,
        };
    },
});
